export interface StringResultDTO {
  result: string;
};

export function StringResultDTO_EmptyObject(): StringResultDTO {
  return {
    result: ""
  }
};
